import { render, staticRenderFns } from "./PaginaTabelleApplicazioneCompensi.vue?vue&type=template&id=546fce50&"
import script from "./PaginaTabelleApplicazioneCompensi.vue?vue&type=script&lang=js&"
export * from "./PaginaTabelleApplicazioneCompensi.vue?vue&type=script&lang=js&"
import style0 from "./PaginaTabelleApplicazioneCompensi.vue?vue&type=style&index=0&id=546fce50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports